import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'

import moment from 'moment'

import InputMask from 'react-input-mask'
import Context from '../../context'
import { ClearStringNumber } from '../../helpers/ClearStringNumber'

export default function ContactForm({ hideBirth, hideCourtesyText }) {
  const { formObject, setFormObject } = useContext(Context)

  const [birthStr, setBirthStr] = useState('')

  const parseBirthContact = () => {
    const birthContact = moment(birthStr, 'DD/MM/YYYY').format('YYYY/MM/DD').toString()
    setFormObject(data => {
      return {
        ...data,
        birthContact
      }
    })
  }

  useEffect(() => {
    console.log('birthContact', formObject.birthContact)

    if (formObject && formObject.birthContact) {
      setBirthStr(moment(formObject.birthContact).format('DD/MM/YYYY').toString())
    }
  }, [formObject.birthContact])

  return (
    <>
      <h5>Contato {!hideCourtesyText && '(Cortesia)'}</h5>
      <div className="row">
        <div className="form-group col-md-8">
          <input
            value={formObject.fullNameContact || ''}
            onChange={e => setFormObject({ ...formObject, fullNameContact: e.target.value })}
            type="text"
            className="form-control"
            placeholder="Nome Completo"
          />
        </div>
        <div className="form-group col-md-4">
          <InputMask
            mask="(99) 9 9999-9999"
            value={formObject.phoneNumberContact || ''}
            onChange={e =>
              setFormObject({
                ...formObject,
                phoneNumberContact: ClearStringNumber(e.target.value)
              })
            }
            type="text"
            className="form-control"
            placeholder="Celular"
          />
        </div>
        <div className={`form-group ${hideBirth ? 'col-md-6' : 'col-md-4'}`}>
          <InputMask
            mask="999.999.999-99"
            value={formObject.CPFContact || ''}
            onChange={e =>
              setFormObject({
                ...formObject,
                CPFContact: ClearStringNumber(e.target.value)
              })
            }
            type="text"
            className="form-control"
            placeholder="CPF"
          />
        </div>
        {!hideBirth && (
          <div className="form-group col-md-4">
            <InputMask
              mask="99/99/9999"
              value={birthStr || ''}
              onChange={e => setBirthStr(e.target.value) || ''}
              onBlur={parseBirthContact}
              type="text"
              className="form-control"
              placeholder="Data de Nascimento"
            />
          </div>
        )}
        <div className={`form-group ${hideBirth ? 'col-md-6' : 'col-md-4'}`}>
          <input
            value={formObject.contactEmail || ''}
            onChange={e => setFormObject({ ...formObject, contactEmail: e.target.value })}
            type="email"
            className="form-control"
            placeholder="E-mail"
          />
        </div>
      </div>
    </>
  )
}

ContactForm.defaultProps = {
  hideBirth: false,
  hideCourtesyText: false
}

ContactForm.propTypes = {
  hideBirth: PropTypes.bool,
  hideCourtesyText: PropTypes.bool
}
